import React, { FC } from 'react';
// import { Formik, Field, Form } from 'formik';
import { Formik, Form } from 'formik';
import AskBeforeLeave from 'components/Modals/AskBeforeLeaveForm';

import BrandSelect from 'components/Form/BrandSelect';
import Loader from 'components/Loaders/SettingsGeneral';
import { Header, Tabs, Tab, Filters, Button } from 'pages/Main/Settings/styles';

import {
  Container,
  Title,
  Card,
  WrapIcon,
  OrderIcon,
  LocationIcon,
  KeyIcon,
  UserIcon,
  // WifiIcon,
  // TicketIcon,
  Row,
  CardTitle,
  CardText,
  // Status,
  // FloatSelect,
  // FloatStatus,
  // SmallText,
  // GreenText,
  // WrapTicket,
  // Select,
  RestaurantInfo,
  // PrinterSettings,
  // Center,
  // ButtonTestPrinter,
} from './styles';
import useConnect from './connect';

const General: FC = () => {
  const {
    general,
    isLoading,
    // printerStatus,
    // testPrinter,
    handleSubmit,
    initialValues,
    selectedBrandId,
    setSelectedBrandId,
  } = useConnect();

  return (
    <Formik onSubmit={handleSubmit} initialValues={initialValues}>
      {({ values }) => (
        <Form noValidate>
          <AskBeforeLeave />
          <Header>
            <Tabs>
              <Tab label="General" to="/settings/general" />
              <Tab label="Working Hours" to="/settings/working-hours" />
              <Tab label="Banking & Legal" to="/settings/banking-legal" />
            </Tabs>
            <Filters>
              <BrandSelect
                value={selectedBrandId}
                setSelectedId={setSelectedBrandId}
                allowAllOption={false}
                inputProps={{ disabled: true }}
              />
              <Button
                color="secondary"
                type="submit"
                disabled={values.printerCopies === ''}
              >
                Publish
              </Button>
            </Filters>
          </Header>
          <Container>
            <RestaurantInfo>
              <Title>Restaurant Info</Title>
              {!general || isLoading ? (
                <Card>
                  <Loader opacity={1} />
                  <Loader opacity={0.75} />
                  <Loader opacity={0.5} />
                  <Loader opacity={0.25} />
                  <Loader opacity={0} />
                </Card>
              ) : (
                <Card>
                  <Row>
                    <WrapIcon>
                      <OrderIcon />
                    </WrapIcon>
                    <CardTitle>Restaurant Name</CardTitle>
                    <CardText>{general?.restaurant.name.displayName}</CardText>
                  </Row>
                  <Row>
                    <WrapIcon>
                      <LocationIcon />
                    </WrapIcon>
                    <CardTitle>Address</CardTitle>
                    <CardText>
                      {`${general?.owner.address.addressLine1} ${general?.owner.address.addressLine2}`}
                      <br />
                      {`${general?.owner.address.city} ${general?.owner.address.state} ${general?.owner.address.zipCode}`}
                      <br />
                    </CardText>
                  </Row>
                  <Row>
                    <WrapIcon>
                      <KeyIcon />
                    </WrapIcon>
                    <CardTitle>Owner name</CardTitle>
                    <CardText>{general?.owner.name.displayName}</CardText>
                  </Row>
                  <Row>
                    <WrapIcon>
                      <UserIcon />
                    </WrapIcon>
                    <CardTitle>Account username</CardTitle>
                    <CardText>{general?.username}</CardText>
                  </Row>
                </Card>
              )}
            </RestaurantInfo>
            {/* <PrinterSettings>
              <Title>Printer settings</Title>
              {!printerStatus || isLoading ? (
                <Card>
                  <Loader opacity={1} />
                  <Loader opacity={0.75} />
                </Card>
              ) : (
                <Card>
                  <Row>
                    <WrapIcon>
                      <WifiIcon />
                    </WrapIcon>
                    <CardTitle>Printer connection</CardTitle>
                    <FloatStatus>
                      <Status status={printerStatus ? 'on' : 'off'} />
                      <CardText>Live</CardText>
                    </FloatStatus>
                  </Row>
                  <Row>
                    <WrapIcon>
                      <TicketIcon />
                    </WrapIcon>
                    <WrapTicket>
                      <CardTitle>Number of receipts</CardTitle>
                      <ButtonTestPrinter type="button">
                        <GreenText role="button" onClick={testPrinter}>
                          Test printer
                        </GreenText>
                      </ButtonTestPrinter>
                    </WrapTicket>
                    <FloatSelect>
                      <Field name="printerCopies" as={Select} type="number">
                        <option value={1}>1</option>
                        <option value={2}>2</option>
                        <option value={3}>3</option>
                      </Field>
                    </FloatSelect>
                  </Row>
                  <Center>
                    <SmallText>
                      Changes will be applied to all restaurants
                    </SmallText>
                  </Center>
                </Card>
              )}
            </PrinterSettings> */}
          </Container>
        </Form>
      )}
    </Formik>
  );
};

export default General;
